import { render, staticRenderFns } from "./ShenPiNewCaiGouFuKuan.vue?vue&type=template&id=79869946&scoped=true&"
import script from "./ShenPiNewCaiGouFuKuan.vue?vue&type=script&lang=js&"
export * from "./ShenPiNewCaiGouFuKuan.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiNewCaiGouFuKuan.vue?vue&type=style&index=0&id=79869946&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79869946",
  null
  
)

export default component.exports